<!--场景体验-->
<template>
  <div class="sceneExperience-layer">
    <div class="center-inner">
      <div class="text-inner">
        <div class="text-inner_wrap">
          <h2>数字人模拟多元客户</h2>
          <p>实战锤炼金融服务应对能力</p>
        </div>
      </div>
      <div class="entrance-inner">
        <div class="item" v-for="item in cardList.zhinengkefu">
          <div class="imgWrap" @click="CaseExperience(item, '智能客服')">
            <img :src="item.imgsrc">
            <p>{{ item.name }}</p>
            <span v-html="item.desc"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetLableItems } from "@/api/flow.api"

export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      cardList: {
        lilunxunlian: [
          { id: 1, name: '数据分析师', imgsrc: require('@imgs/sceneExperience/Slice1.png'), desc: '描述文本描述文本描述文本描述文本描述文本', url: '' },
          { id: 2, name: '经济分析师', imgsrc: require('@imgs/sceneExperience/Slice2.png'), desc: '描述文本描述文本描述文本描述文本描述文本', url: '' },
          { id: 3, name: '训练师', imgsrc: require('@imgs/sceneExperience/Slice3.png'), desc: '描述文本描述文本描述文本描述文本描述文本', url: '' },
        ],
        zhinengkefu: [
          // { id: 4, name: '银行AI训练师', imgsrc: require('@imgs/sceneExperience/Group_258@2x.png'), desc: '提供涵盖综合金融、零售银行及对公业务的全方位岗位训练：覆盖储蓄、转账、信贷等基础银行业务操作。', url: '', scenarioName: '训练智能体' },
          { id: 4, name: '银行交互场景：信用卡+小额理财', imgsrc: require('@imgs/sceneExperience/Group_264@2x.png'), desc: '<b>数字人关键信息：</b><br>姓名：林溪（23岁，短视频内容策划）<br>角色标签：潮流消费型Z世代<br>学生任务：扮演金融顾问，推荐“免年费、积分换潮流权益”的信用卡及1元起投小额理财', url: window.JumpUrl1, scenarioName: '训练智能体' },
          // { id: 1, name: '信用卡AI专家智能体', imgsrc: require('@imgs/sceneExperience/Group_261@2x.png'), desc: '提供信用卡相关咨询，如办卡条件、额度提升、账单查询、还款方式、优惠活动等，帮助用户快速了解和使用信用卡服务。', url: '', scenarioName: '智能客服' },
          { id: 1, name: '交互场景：房贷优化+子女教育金理财', imgsrc: require('@imgs/sceneExperience/Group_259@2x.png'), desc: '<b>数字人关键信息：</b><br>姓名：张磊（32岁，建筑工程项目经理）<br>角色标签：家庭责任型青年<br>学生任务：扮演金融客服，提供低息房贷置换方案+低风险教育金理财', url: window.JumpUrl2, scenarioName: '智能客服' },
          // { id: 2, name: '理财顾问岗陪练', imgsrc: require('@imgs/sceneExperience/Group_256@2x.png'), desc: '提供理财顾问陪练服务，经智能体工作流搭建，参考知识库训练用户，借AI评分反馈，助您提升理财顾问专业能力 。', url: '', scenarioName: '训练智能体' },
          { id: 2, name: '交互场景：养老年金理财+医疗补充险', imgsrc: require('@imgs/sceneExperience/Group_265@2x.png'), desc: '<b>数字人关键信息：</b><br>姓名：陈建国（56岁，国企行政部主任）<br>角色标签：品质养老型准银发族<br>学生任务：扮演金融分析师，推荐保本型养老年金+覆盖进口药的医疗险', url: window.JumpUrl4, scenarioName: '训练智能体' },
          // { id: 3, name: '贷款AI专家智能体', imgsrc: require('@imgs/sceneExperience/Group_265@2x.png'), desc: '针对贷款业务，提供贷款种类介绍、申请条件说明、贷款额度与利率详情、办理流程指导、还款注意事项等服务，满足用户资金需求相关疑问。', url: '', scenarioName: '智能客服' },
          { id: 3, name: '交互场景：高端理财+财富传承', imgsrc: require('@imgs/sceneExperience/Group_260@2x.png'), desc: '<b>数字人关键信息：</b><br>姓名：赵雅（44岁，外资科技公司中国区运营总监）<br>角色标签：高净值企业高管<br>学生任务：扮演高净值理财顾问，提供定制化资产配置+财富传承方案', url: window.JumpUrl3, scenarioName: '智能客服' },
        ],
        touziyanjiu: [
          { id: 1, name: '投研助手XX', imgsrc: require('@imgs/sceneExperience/Slice1.png'), desc: '描述文本描述文本描述文本描述文本描述文本', url: '' },
          { id: 2, name: '投研助手XX', imgsrc: require('@imgs/sceneExperience/Slice2.png'), desc: '描述文本描述文本描述文本描述文本描述文本', url: '' },
        ],
        extend1: [
          { id: 1, name: 'XXXX', imgsrc: require('@imgs/sceneExperience/Slice1.png'), desc: '描述文本描述文本描述文本描述文本描述文本', url: '' },
          { id: 2, name: 'XXXX', imgsrc: require('@imgs/sceneExperience/Slice2.png'), desc: '描述文本描述文本描述文本描述文本描述文本', url: '' },
        ]
      },
      PldUrl: window.PldUrl,
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getFlowID()
  },
  mounted () { },
  methods: {
    // 开始练习/考核
    CaseExperience (item) {
      //这里直接进入案例体验
      sessionStorage.setItem('isCJTY', 1)
      // sessionStorage.setItem('scenarioName', '智能客服')
      sessionStorage.setItem('scenarioName', item.scenarioName)
      // sessionStorage.setItem('znkf_key', 'dygpt-xVvOqc2X5bjYEbFKSEE5i97v0flsDea5opUDvSR6bnr86N6GRuUOFVqjNmcEB')
      sessionStorage.setItem('znkf_key', window.CJTY_AIwenda_token)

      if (item.name == '理财顾问岗陪练') {
        sessionStorage.setItem('xlznt_tw_key', window.CJTY_AItiwen_token2)
        sessionStorage.setItem('xlznt_jf_key', window.CJTY_AIjifen_token2)
      } else {
        sessionStorage.setItem('xlznt_tw_key', window.CJTY_AItiwen_token)
        sessionStorage.setItem('xlznt_jf_key', window.CJTY_AIjifen_token)
      }
      // sessionStorage.setItem('xlznt_tw_key', window.CJTY_AItiwen_token)
      // sessionStorage.setItem('xlznt_jf_key', window.CJTY_AIjifen_token)

      sessionStorage.setItem('znkf_key_save', '')
      sessionStorage.setItem('xlznt_tw_key_save', '')
      sessionStorage.setItem('xlznt_jf_key_save', '')
      //如果是智能客服
      // this.$router.push({ path: '/case/zhinengkefu', query: { type: this.type } })
      // this.$router.push({ path: '/case/zhinengkefu' })
      window.open(item.url)
    },

    // 获取智能体流ID
    getFlowID () {
      GetLableItems().then(res => {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].lableName == '客服工作流') {
              window.CJTY_AIwenda_token = res.data[i].key
            }
            if (res.data[i].lableName == '问答工作流') {
              window.CJTY_AItiwen_token = res.data[i].key
            }
            if (res.data[i].lableName == '计分工作流') {
              window.CJTY_AIjifen_token = res.data[i].key
            }
          }
          sessionStorage.setItem('znkf_key', window.CJTY_AIwenda_token)
          sessionStorage.setItem('xlznt_tw_key', window.CJTY_AItiwen_token)
          sessionStorage.setItem('xlznt_jf_key', window.CJTY_AIjifen_token)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.sceneExperience-layer {
  width: 100%;
  height: 100%;
  overflow: auto;
  color: #fff;
  display: flex;
  align-items: center;
  user-select: none;

  .center-inner {
    width: 100%;
    position: relative;
    padding-left: 4.6rem;
    box-sizing: border-box;

    .text-inner {
      width: 100%;
      height: 3.2rem;
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -1.6rem;
      background-color: rgba(0, 0, 0, 0.4);
      display: flex;
      align-items: center;
      backdrop-filter: blur(5px);

      .text-inner_wrap {
        width: 5rem;
        margin-left: 0.5rem;
        text-shadow: 0 0 4px rgba(255, 255, 255, 0.6);

        h2 {
          font-size: 0.43rem;
          margin-bottom: 0.4rem;
          background: url('~@imgs/sceneExperience/jiantou_1@2x.png') no-repeat right center;
          background-size: 1rem auto;
        }

        p {
          font-size: 0.2rem;
          line-height: 1.5;
          margin: 0 auto;
          text-align: left;
          font-family: '宋体';
        }

        p,
        span {
          pointer-events: none;
        }
      }
    }

    .entrance-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .item {
        text-align: center;
        cursor: pointer;
        text-shadow: 0 0 1px #0c2a6b;

        &:last-child {
          margin-right: 0;
        }

        .imgWrap {
          height: 5.2rem;
          width: 2.6rem;
          position: relative;
          text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);

          &:hover {
            scale: 1.02;

            img {
              filter: drop-shadow(0 0 10px rgba(120, 215, 255, 0.5));
              opacity: 1;
            }
          }

          img {
            height: 5.2rem;
            width: 3.8rem;
            object-fit: contain;
            position: relative;
            left: -0.5rem;
            opacity: 0.85;
          }

          p {
            width: 100%;
            font-weight: bold;
            font-size: 0.2rem;
            position: absolute;
            top: 0.1rem;
            left: 0.68rem !important;
            padding: 0 0.25rem;
            box-sizing: border-box;
            line-height: 1.2;
          }

          span {
            position: absolute;
            bottom: 0.2rem;
            left: -0.95rem;
            padding: 0 0.8rem;
            font-size: 0.15rem;
            line-height: 1.3;
            transform: skewX(164deg);
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
